module.exports = __webpack_public_path__ + "img/expostyle_1722_candy_pink_pantone223c.f19b2aa9.jpg";